<template>
  <vue-collapsible-panel-group base-color="#2d2b3b">
    <vue-collapsible-panel v-for="(title, key) in titles" :key="key" :expanded="false">
      <template #title>
        {{ title }}
      </template>
      <template #content>
        {{ ' ' }}
        <component :is="listComponents[key]"></component>
      </template>
    </vue-collapsible-panel>
  </vue-collapsible-panel-group>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import FaqPhotos from 'components/ContactPage/FaqPhotos.vue'
  import FaqRenew from 'components/ContactPage/FaqRenew.vue'
  import FaqStatusAccount from 'components/ContactPage/FaqStatusAccount.vue'
  import FaqSugestion from 'components/ContactPage/FaqSugestion.vue'
  import FaqContact from 'components/ContactPage/FaqContact.vue'

  export default defineComponent({
    name: 'CollapseBox',
    props: {
      titles: {
        required: true
      }
    },
    components: {
      FaqPhotos,
      FaqRenew,
      FaqStatusAccount,
      FaqSugestion,
      FaqContact
    },
    data() {
      return {
        listComponents: ['FaqRenew', 'FaqStatusAccount', 'FaqPhotos', 'FaqSugestion', 'FaqContact']
      }
    }
  })
</script>

<style lang="css" scoped>
  .vcpg {
    color: #000;
    border: none !important;
  }

  .vcpg :deep(.vcp__header) {
    border-radius: 35px;
    background-color: #f8f8f8 !important;
    margin-top: 10px;
    padding: 26px;
    border: 1px solid var(--border-color);
  }

  .vcpg :deep(.vcp__body) {
    border-top: none !important;
    height: auto;
  }

  .vcpg :deep(.vcp__header-title) {
    color: #000000;
    font-family: 'Roboto-Bold';
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
  }

  .vcpg :deep(.vcp__body-content h5)  {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;    
  }

  .vcpg :deep(.vcp__body-content h3)  {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;    
  }

  .vcpg :deep(.vcp__body-content p)  {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;    
  }

  .vcpg :deep(.vcp__body-content span)  {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;    
  }

  .vcpg :deep(.vcp__body-content li)  {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;    
  }
</style>
